import axios from 'axios'
import qs from 'qs'

axios.interceptors.request.use((config)=>{
  if(config.method === 'post' && config.data instanceof FormData){
    console.log(config);
  }else if(config.method === 'post'){
    config.data = qs.stringify(config.data);
  }
  return config;
},(error)=>{
  return Promise.reject(error);
})

axios.interceptors.response.use((response)=>{
  return response
})

export default axios;


// WEBPACK FOOTER //
// ./src/common/axios.js